import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Vue from 'vue'

@Module({
  namespaced: true
})
export default class CatalogStore extends VuexModule {
  saleCategoriesLoaded = false
  saleCategories: KwixeoCatalog.SaleCategories = []
  chargeCategoriesLoaded = false
  chargeCategories: KwixeoCatalog.ChargeCategories = []
  variationLevelsLoaded = false
  variationLevels: KwixeoCatalog.VariationLevels = []
  stockLocationsLoaded = false
  stockLocations: KwixeoCatalog.StockLocations = []

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['SaleCategories', 'ChargeCategories', 'VariationLevels', 'StockLocations']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
  }

  // Sort a list alphabetically
  @Mutation
  orderList (param: { list: KwixeoInterface.GenericObject[]; key: string }): void {
    const key = param.key
    param.list.sort((a, b) => {
      const aKey = a[key].toLowerCase()
      const bKey = b[key].toLowerCase()
      if (aKey < bKey) return -1
      else if (aKey > bKey) return 1
      else return 0
    })
  }

  // Change the loaded state
  @Mutation
  setSaleCategoriesLoaded (state = true): void {
    this.saleCategoriesLoaded = state
  }

  // Set the sale categories
  @Mutation
  setSaleCategories (saleCategories: KwixeoCatalog.SaleCategories): void {
    this.saleCategories = saleCategories
  }

  // Add or update a sale category
  @Mutation
  updateSaleCategory (saleCategory: KwixeoCatalog.SaleCategory): void {
    if (!this.saleCategoriesLoaded) {
      return
    }
    const index = this.saleCategories.findIndex(type => type.id === saleCategory.id)
    if (index >= 0) {
      Vue.set(this.saleCategories, index, saleCategory)
    } else {
      this.saleCategories.push(saleCategory)
    }
  }

  // Remove a sale category
  @Mutation
  removeSaleCategory (saleCategory: KwixeoCatalog.SaleCategory): void {
    if (!this.saleCategoriesLoaded) {
      return
    }
    const index = this.saleCategories.findIndex(type => type.id === saleCategory.id)
    if (index >= 0) {
      Vue.delete(this.saleCategories, index)
    }
  }

  // Load the customer types for server
  @Action
  async loadSaleCategories (force = false): Promise<void> {
    if (!this.saleCategoriesLoaded || force) {
      const response = await Vue.prototype.$kwCatalog.axios.get('/catalog/sale_category?per_page=500&sort=label&include=customPrices')
      await this.context.commit('setSaleCategories', response.data.data)
      this.context.commit('setSaleCategoriesLoaded')
    }
  }

  // Add or update a customer type
  @Action
  setSaleCategory (saleCategory: KwixeoCatalog.SaleCategory): void {
    this.context.commit('updateSaleCategory', saleCategory)
    if (this.saleCategoriesLoaded) {
      this.context.commit('orderList', { list: this.saleCategories, key: 'label' })
    }
  }

  // Delete a customer type
  @Action
  deleteSaleCategory (saleCategory: KwixeoCatalog.SaleCategory): void {
    this.context.commit('removeSaleCategory', saleCategory)
  }


  // Change the loaded state
  @Mutation
  setChargeCategoriesLoaded (state = true): void {
    this.chargeCategoriesLoaded = state
  }

  // Set the charge categories
  @Mutation
  setChargeCategories (chargeCategories: KwixeoCatalog.ChargeCategories): void {
    this.chargeCategories = chargeCategories
  }

  // Add or update a charge category
  @Mutation
  updateChargeCategory (chargeCategory: KwixeoCatalog.ChargeCategory): void {
    if (!this.chargeCategoriesLoaded) {
      return
    }
    const index = this.chargeCategories.findIndex(type => type.id === chargeCategory.id)
    if (index >= 0) {
      Vue.set(this.chargeCategories, index, chargeCategory)
    } else {
      this.chargeCategories.push(chargeCategory)
    }
  }

  // Remove a charge category
  @Mutation
  removeChargeCategory (chargeCategory: KwixeoCatalog.ChargeCategory): void {
    if (!this.chargeCategoriesLoaded) {
      return
    }
    const index = this.chargeCategories.findIndex(type => type.id === chargeCategory.id)
    if (index >= 0) {
      Vue.delete(this.chargeCategories, index)
    }
  }

  // Load the customer types for server
  @Action
  async loadChargeCategories (force = false): Promise<void> {
    if (!this.chargeCategoriesLoaded || force) {
      const response = await Vue.prototype.$kwCatalog.axios.get('/catalog/charge_category?per_page=500&sort=label')
      await this.context.commit('setChargeCategories', response.data.data)
      this.context.commit('setChargeCategoriesLoaded')
    }
  }

  // Add or update a customer type
  @Action
  setChargeCategory (chargeCategory: KwixeoCatalog.ChargeCategory): void {
    this.context.commit('updateChargeCategory', chargeCategory)
    if (this.chargeCategoriesLoaded) {
      this.context.commit('orderList', { list: this.chargeCategories, key: 'label' })
    }
  }

  // Delete a customer type
  @Action
  deleteChargeCategory (chargeCategory: KwixeoCatalog.ChargeCategory): void {
    this.context.commit('removeChargeCategory', chargeCategory)
  }


  // Change the loaded state
  @Mutation
  setVariationLevelsLoaded (state = true): void {
    this.variationLevelsLoaded = state
  }

  // Set the charge categories
  @Mutation
  setVariationLevels (variationLevels: KwixeoCatalog.VariationLevels): void {
    this.variationLevels = variationLevels
  }

  // Add or update a charge category
  @Mutation
  updateVariationLevel (variationLevel: KwixeoCatalog.VariationLevel): void {
    if (!this.variationLevelsLoaded) {
      return
    }
    const index = this.variationLevels.findIndex(type => type.id === variationLevel.id)
    if (index >= 0) {
      Vue.set(this.variationLevels, index, variationLevel)
    } else {
      this.variationLevels.push(variationLevel)
    }
  }

  // Remove a charge category
  @Mutation
  removeVariationLevel (variationLevel: KwixeoCatalog.VariationLevel): void {
    if (!this.variationLevelsLoaded) {
      return
    }
    const index = this.variationLevels.findIndex(type => type.id === variationLevel.id)
    if (index >= 0) {
      Vue.delete(this.variationLevels, index)
    }
  }

  // Load the customer types for server
  @Action
  async loadVariationLevels (force = false): Promise<void> {
    if (!this.variationLevelsLoaded || force) {
      const response = await Vue.prototype.$kwCatalog.axios.get('/catalog/variation?per_page=500&sort=label')
      await this.context.commit('setVariationLevels', response.data.data)
      this.context.commit('setVariationLevelsLoaded')
    }
  }

  // Add or update a customer type
  @Action
  setVariationLevel (variationLevel: KwixeoCatalog.VariationLevel): void {
    this.context.commit('updateVariationLevel', variationLevel)
    if (this.variationLevelsLoaded) {
      this.context.commit('orderList', { list: this.variationLevels, key: 'label' })
    }
  }

  // Delete a customer type
  @Action
  deleteVariationLevel (variationLevel: KwixeoCatalog.VariationLevel): void {
    this.context.commit('removeVariationLevel', variationLevel)
  }



  // Change the loaded state
  @Mutation
  setStockLocationsLoaded (state = true): void {
    this.stockLocationsLoaded = state
  }

  // Set the charge categories
  @Mutation
  setStockLocations (stockLocations: KwixeoCatalog.StockLocations): void {
    this.stockLocations = stockLocations
  }

  // Add or update a charge category
  @Mutation
  updateStockLocation (stockLocation: KwixeoCatalog.StockLocation): void {
    if (!this.stockLocationsLoaded) {
      return
    }
    const index = this.stockLocations.findIndex(type => type.id === stockLocation.id)
    if (index >= 0) {
      Vue.set(this.stockLocations, index, stockLocation)
    } else {
      this.stockLocations.push(stockLocation)
    }
  }

  // Remove a charge category
  @Mutation
  removeStockLocation (stockLocation: KwixeoCatalog.StockLocation): void {
    if (!this.stockLocationsLoaded) {
      return
    }
    const index = this.stockLocations.findIndex(type => type.id === stockLocation.id)
    if (index >= 0) {
      Vue.delete(this.stockLocations, index)
    }
  }

  // Load the customer types for server
  @Action
  async loadStockLocations (force = false): Promise<void> {
    if (!this.stockLocationsLoaded || force) {
      const response = await Vue.prototype.$kwCatalog.axios.get('/catalog/stock/location?per_page=500&sort=name&include=country')
      await this.context.commit('setStockLocations', response.data.data)
      this.context.commit('setStockLocationsLoaded')
    }
  }

  // Add or update a customer type
  @Action
  setStockLocation (stockLocation: KwixeoCatalog.StockLocation): void {
    this.context.commit('updateStockLocation', stockLocation)
    if (this.stockLocationsLoaded) {
      this.context.commit('orderList', { list: this.stockLocations, key: 'name' })
    }
  }

  // Delete a customer type
  @Action
  deleteStockLocation (stockLocation: KwixeoCatalog.StockLocation): void {
    this.context.commit('removeStockLocation', stockLocation)
  }
}
